import ExcelJS from "exceljs";

const HEADERS = [
  "Nummer", "Art", "Liter/kg", "Ablaufdatum", "Blombe gezogen", "Zum Einsatz gekommen", "Standort", "Bemerkungen"
];

export async function exportFeuerloescherToExcel(list, isTrash = false) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Feuerlöscher");

  // Kopfzeile
  ws.addRow(HEADERS);
  ws.getRow(1).font = { bold: true, size: 12 };
  ws.getRow(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDEEAF6' } };

  // Zeilen
  list.forEach(e => {
    const row = [
      e.nummer,
      e.art,
      e.menge,
      e.ablauf,
      e.blombe ? "Ja" : "Nein",
      e.einsatz ? "Ja" : "Nein",
      e.standort,
      e.bemerkung
    ];
    const excelRow = ws.addRow(row);
    // Farbliche Markierung
    let color = 'FFFFFFFF';
    if (e.einsatz) color = 'FFBDBDBD'; // grau
    else if (!e.ablauf) color = 'FFFFFFFF';
    else {
      const d = new Date(e.ablauf);
      const now = new Date();
      if (d < now) color = 'FFFFCDD2'; // rot
      else if ((d - now) / (1000 * 60 * 60 * 24) < 60) color = 'FFFFF9C4'; // gelb
      else color = 'FFE8F5E9'; // grün
    }
    excelRow.eachCell(cell => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: color } };
      cell.font = { size: 12 };
    });
  });

  // Spaltenbreiten
  [16, 14, 10, 16, 16, 18, 24, 24].forEach((w, i) => ws.getColumn(i + 1).width = w);

  // Download
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = isTrash ? 'Feuerloescher_Papierkorb.xlsx' : 'Feuerloescher.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export async function importFeuerloescherFromExcel(file) {
  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(await file.arrayBuffer());
  const ws = wb.worksheets[0];
  const rows = [];
  ws.eachRow((row, idx) => {
    if (idx === 1) return; // Kopfzeile
    const [nummer, art, menge, ablauf, blombe, einsatz, standort, bemerkung] = row.values.slice(1);
    rows.push({
      nummer: nummer || "",
      art: art || "",
      menge: menge || "",
      ablauf: ablauf || "",
      blombe: blombe === "Ja",
      einsatz: einsatz === "Ja",
      standort: standort || "",
      bemerkung: bemerkung || ""
    });
  });
  return rows;
} 